import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { FISP_TV_ADMIN_LOGIN_PATH } from "../config";
import { isFispTvAdminAuthenticated } from "../session";

export default function AdminGuard({ children }) {
    const location = useLocation();

    if (!isFispTvAdminAuthenticated()) {
        const redirectTarget = `${location.pathname}${location.search}${location.hash}`;
        return <Navigate to={FISP_TV_ADMIN_LOGIN_PATH} replace state={{ from: redirectTarget }} />;
    }

    return children;
}
